export const GET_ALL_ACTIVITIES = "GET_ALL_ACTIVITIES";
export const GET_ALL_PAGINATED_ACTIVITIES = "GET_ALL_PAGINATED_ACTIVITIES";
export const RESET_DATA = "RESET_DATA";

// Loading action types
export const START_LOADING_ACTIVITIES = "START_LOADING_ACTIVITIES";
export const STOP_LOADING_ACTIVITIES = "STOP_LOADING_ACTIVITIES";

export const APPEND_NEW_COMMENT = "APPEND_NEW_COMMENT";